import React, { PureComponent } from "react";

export default class ChecboxIcon extends PureComponent {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="3195 6030 18 18" {...this.props}>
				<path
					id="path"
					d="M19,5V19H5V5Zm0-2H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5a2.006,2.006,0,0,0-2-2Z"
					transform="translate(3192 6027)"
				/>
			</svg>
		);
	}
}
